import { PayloadAction } from '@reduxjs/toolkit';
import { GamesResults, GamesState } from '../state';

export const fetchGamesResults = (state: GamesState, action: PayloadAction<GamesResults>) => {
    state.results = action.payload;
}

export const changeYear = (state: GamesState, action: PayloadAction<number>) => {
    state.year = action.payload;
}
